import $ from "jquery";

const applycoupon = () => {
  const init = () => {
    execute();
  };

  const execute = () => {
    const el = {
      input: "#js-apply-coupon",
      codecupon: "#coupon_code",
      btnSubmit: ".woocommerce-cart-form button[name='apply_coupon']",
      newBtnSubmit: ".js-checkout-apply-coupon__button",
    };

    if ($(el.input).length === 0) return;

    $(document).on("input", el.input, function (e) {
      e.preventDefault();

      $(el.codecupon).val($(this).val());
    });

    $(document).on("blur", el.input, function () {
      if ($(this).val() == "") return;
      $(el.codecupon).val($(this).val());
      $(el.btnSubmit).trigger("click");
    });

    $(document).on("keypress", el.input, function (e) {
      const keycode = e.originalEvent.key;
      if (keycode !== "Enter") return;
      if ($(this).val() == "") return;
      $(el.codecupon).val($(this).val());
      $(el.btnSubmit).trigger("click");
    });
  };

  init();
};

try {
  applycoupon();
} catch (error) {
  // eslint-disable-next-line no-console
  console.error(error);
}
